$(document).ready(function() {
    $('.product-slider').slick({
        autoplay: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0811/2400/0061/files/prev.xml?v=1702462138'>",
        nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0811/2400/0061/files/next.xml?v=1702462262'>",
        infinite: true,
        dots: false,
        asNavFor: '.product-slider-thumbnail'
    });
    $('.product-slider-thumbnail').slick({
        vertical: true,
        autoplay: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.product-slider',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        variableWidth: false,
        responsive: [{
                breakpoint: 991,
                settings: {
                    vertical: false,
                    arrows: false,
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.featured-logos-slider').slick({
        dots: false,
        autoplay: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.addon-slider').slick({
        dots: false,
        autoplay: false,
        arrows: true,
        prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0811/2400/0061/files/prev.svg?v=1698732462'>",
        nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0811/2400/0061/files/next.svg?v=1698732462'>",
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('.customers-slider').slick({
        dots: true,
        adaptiveHeight: true,
        autoplay: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 590,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
});

$(document).ready(function() {
    $('.buy-bundle-item').click(function() {
        $('.buy-bundle-item').removeClass('bundle-active');
        $(this).addClass('bundle-active');
    });
});

$(document).ready(function() {
    $('.buy-color-item').click(function() {
        $('.buy-color-item').removeClass('color-active1');
        $(this).addClass('color-active1');
    });
});

$(document).ready(function() {
    $('.included-slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0811/2400/0061/files/prev2.svg?v=1698732462'>",
        nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0811/2400/0061/files/next2.svg?v=1698732462'>",
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
});
// Quick model popup


$(document).on("click", ".card__content .quick-add .quick-add__submit", function() {
    console.log('clickkkkk');
    setTimeout(function() {
        console.log('click');
        $('.quick-add-modal__content-info .product-slider').slick({
            autoplay: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: false,
            infinite: true,
            dots: false,
            asNavFor: '.product-slider-thumbnail'
        });
        $('.quick-add-modal__content-info .product-slider-thumbnail').slick({
            vertical: true,
            autoplay: false,
            prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0811/2400/0061/files/prev.svg?v=1698732462'>",
            nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0811/2400/0061/files/p-next.svg?v=1698732462'>",
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.product-slider',
            dots: false,
            arrows: true,
            focusOnSelect: true,
            variableWidth: false,
            responsive: [{
                    breakpoint: 991,
                    settings: {
                        vertical: false,
                        arrows: false,
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
        $(document).ready(function() {
            $('.buy-color-item').click(function() {
                $('.buy-color-item').removeClass('color-active1');
                $(this).addClass('color-active1');
            });
        });
        $('.product-form__input input').change(function() {
            var swatch_val = $(this).val();
            // console.log(swatch_val);
            //  console.log("hello word");

            $(".product-slider-thumbnail .product-thumb-item").each(function() {
                var mediaValue = $(this).attr('value');
                // var mediaval = document.querySelectorAll(".product-slider-thumbnail .product-thumb-item").value;
                // console.log(mediaValue);
                if (swatch_val == mediaValue) {
                    // console.log(mediaValue , "media value");
                    $('.product-slider-thumbnail .product-thumb-item[value="' + mediaValue + '"]').click();
                }
            });
        });
        $('.buy-bundle-item').click(function() {
            $('.buy-bundle-item').removeClass('bundle-active');
            $(this).addClass('bundle-active');
        });
        $('.buy-bundle-offers .buy-bundle-item:first-child').addClass('bundle-active');
        $('.buy-bundle-offers .buy-bundle-item').click(function() {
            if ($(this).hasClass('bundle-active')) {
                console.log('has Class');
                var get_Attr = $(this).attr("qty");
                var set_attr = $('.price-per-item__container .quantity__input').attr('value', get_Attr);
            }

            if ($('.buy-bundle-offers .buy-bundle-item.click_show_qty').hasClass('bundle-active')) {
                $('.buy-product-action-row .quantity-form-block').css('display', 'block');
            } else {
                $('.buy-product-action-row .quantity-form-block').css('display', 'none');
            }

        });

    }, 2000);
});

//  on swatch click change variantg image: 
$('.product-form__input input').change(function() {
    var swatch_val = $(this).val();
    // console.log(swatch_val);
    //  console.log("hello word");

    $(".product-slider-thumbnail .product-thumb-item").each(function() {
        var mediaValue = $(this).attr('value');
        // var mediaval = document.querySelectorAll(".product-slider-thumbnail .product-thumb-item").value;
        // console.log(mediaValue);
        if (swatch_val == mediaValue) {
            // console.log(mediaValue , "media value");
            $('.product-slider-thumbnail .product-thumb-item[value="' + mediaValue + '"]').click();
        }
  });
});




// On variant change: sale price 
$('.buy-color-row .buy-color-inner-row .varinat-option').change(function() {
    console.log('Change');
    setTimeout(function() {
        var old_Price = $('.price__sale .buy-product-price-old');
        var new_Price = $('.price__sale .buy-product-price');
        // console.log(old_Price , new_Price , 'old_Price ====> new_Price');
        var finalOld = old_Price.text().replace('$', '');
        var finalNew = new_Price.text().replace('$', '');
        var calc = finalOld - finalNew;
        $('.buy-product-price-badge-span.price_change').html('$' + calc.toFixed(2));

    }, 2000);
});


// Quantity Offer : 
$(document).ready(function() {
    $('.buy-bundle-offers .buy-bundle-item:first-child').addClass('bundle-active');
    $('.buy-bundle-offers .buy-bundle-item').click(function() {
        if ($(this).hasClass('bundle-active')) {
            // console.log('has Class');
            var get_Attr = $(this).attr("qty");
            var set_attr = $('.price-per-item__container .quantity__input').attr('value', get_Attr);
        }

        if ($('.buy-bundle-offers .buy-bundle-item.click_show_qty').hasClass('bundle-active')) {
            $('.buy-product-action-row .quantity-form-block').css('display', 'block');
        } else {
            $('.buy-product-action-row .quantity-form-block').css('display', 'none');
        }

        // Price change on discount: 
        var price = $('.buy-product-price-col .price__sale .buy-product-price').text().replace('$', '');
        var discount = $('.buy-bundle-item.bundle-active').attr('discounttext');
        var afterDiscount = $('.product-form__submit .discount_price').html();
        afterDiscount = price - (price * discount / 100);
        // console.log(afterDiscount , 'afterDiscount');
        $('.discount_price').text('- $' + afterDiscount.toFixed(2));
    });

    $('.buy-color-inner-row .varinat-option').change(function() {
        setTimeout(function() {
            // Price change on discount: 
            var price = $('.buy-product-price-col .price__sale .buy-product-price').text().replace('$', '');
            var discount = $('.buy-bundle-item.bundle-active').attr('discounttext');
            var afterDiscount = $('.product-form__submit .discount_price').html( );
            afterDiscount = price - (price * discount / 100);
            // console.log(afterDiscount , 'afterDiscount');
            $('.discount_price').text('- $' + afterDiscount.toFixed(2));
        }, 2000);
    });


    $('.addon-color-col .varinat-option').change(function() {
        // console.log('changes');
        var btn_text = $('.addon-content-bottom-row').find('.product-form__buttons .custom_product-form__submit span');
        var btn_disable = $('.addon-content-bottom-row').find('.product-form__buttons .custom_product-form__submit');
        setTimeout(function() {
            $(btn_text).html('Add To Cart');
            $(btn_disable).removeAttr('disabled');
        }, 1000);
    });

    //  Tabbing banner
    $(".featured-product-wrap .featured-product-point-wrap .featured-product-point-box-inner").click(function() {
        console.log('click');
        if ($(this).find('.featured-product-item').hasClass("shown")) {
            $(this).find('.featured-product-item').addClass("hidn");
            $(this).find('.featured-product-item').removeClass("shown");
        } else {
            $(".featured-product-item").removeClass("shown");
            $(".featured-product-item").addClass("hidn");
            $(this).find('.featured-product-item').addClass("shown");
            $(this).find('.featured-product-item').removeClass("hidn");
        }
    });


});

//  Tabbing JS: 
// function toggleIcon(expandIconPlus, expandIconMinus, isOpen) {
//     if (isOpen) {
//         expandIconPlus.style.display = 'none';
//         expandIconMinus.style.display = 'block';
//     } else {
//         expandIconPlus.style.display = 'block';
//         expandIconMinus.style.display = 'none';
//     }
// }

// function createAccordion(el) {
//     let animation = null;
//     let isClosing = false;
//     let isExpanding = false;
//     const summary = el.querySelector('summary');
//     const content = el.querySelector('.faq-content');
//     const expandIconPlus = summary.querySelector('.icon-tabler-circle-plus');
//     const expandIconMinus = summary.querySelector('.icon-tabler-circle-minus');

//     function onClick(e) {
//         e.preventDefault();
//         el.style.overflow = 'hidden';
//         if (isClosing || !el.open) {
//             open();
//         } else if (isExpanding || el.open) {
//             shrink();
//         }
//     }

//     function shrink() {
//         isClosing = true;
//         const startHeight = `${el.offsetHeight}px`;
//         const endHeight = `${summary.offsetHeight}px`;
//         if (animation) {
//             animation.cancel();
//         }
//         animation = el.animate({
//             height: [startHeight, endHeight]
//         }, {
//             duration: 400,
//             easing: 'ease-out'
//         });
//         animation.onfinish = () => {
//             toggleIcon(expandIconPlus, expandIconMinus, false);
//             onAnimationFinish(false);
//         };
//         animation.oncancel = () => {
//             toggleIcon(expandIconPlus, expandIconMinus, false);
//             isClosing = false;
//         };
//     }

//     function open() {
//         el.style.height = `${el.offsetHeight}px`;
//         el.open = true;
//         window.requestAnimationFrame(expand);
//     }

//     function expand() {
//         isExpanding = true;
//         const startHeight = `${el.offsetHeight}px`;
//         const endHeight = `${summary.offsetHeight + content.offsetHeight}px`;
//         if (animation) {
//             animation.cancel();
//         }
//         animation = el.animate({
//             height: [startHeight, endHeight]
//         }, {
//             duration: 350,
//             easing: 'ease-out'
//         });
//         animation.onfinish = () => {
//             toggleIcon(expandIconPlus, expandIconMinus, true);
//             onAnimationFinish(true);
//         };
//         animation.oncancel = () => {
//             toggleIcon(expandIconPlus, expandIconMinus, true);
//             isExpanding = false;
//         };
//     }

//     function onAnimationFinish(open) {
//         el.open = open;
//         animation = null;
//         isClosing = false;
//         isExpanding = false;
//         el.style.height = el.style.overflow = '';
//     }

//     summary.addEventListener('click', onClick);
// }

// document.querySelectorAll('details').forEach(createAccordion);